/*
 * File per la definizione dei Controller Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/controller
 */
define([
    'angular',
    'file-saver'
],

    function (angular, fileSaver) {

        var invioAccreditamentoControllers = angular.module('invioAccreditamentoControllers', []);

        invioAccreditamentoControllers.controller('InvioRichiestaAccreditamentoCtrl', ['$rootScope', '$scope', '$log', '$timeout', '$window', 'CONSTANTS', 'MessageService', 'ResourceService', InvioRichiestaAccreditamentoCtrl]);

        function InvioRichiestaAccreditamentoCtrl($rootScope, $scope, $log, $timeout, $window, CONSTANTS, MessageService, ResourceService) {
            var vm = this;
            vm.invioClicked = false;

            vm.formRicerca = undefined;
            vm.input = {};
            vm.annullata = false;
            vm.datiInvio = undefined;
            vm.inputCaptcha = "";
            $rootScope.abilitaDelega = true;
            vm.abilitaCaricamentoFileP7m = false;
            vm.fileOK = false;
            vm.fileInviato = false;
            vm.azioneConferma = 'ricerca';

            //services
            vm.MessageService = MessageService;

            vm.actionDisabled = function () {
                if (vm.formRicerca.$invalid || vm.invioClicked) {
                    return true;
                }
                return false;
            }

            vm.annullaOperazione = function () {
                vm.isClean = true;
                angular.element("#modal-conferma").modal('show');
            }

            vm.annulla = function () {
                angular.element("#modal-conferma").modal('hide');
                $timeout(function () {
                    vm.input = {};
                    vm.invioClicked = false;
                    vm.formRicerca.$setPristine();
                    MessageService.clearMessages();
                    $window.scroll(0, 0);
                }, 500);
            }

            vm.confermaOperazione = function () {
                vm.isClean = false;
                angular.element("#modal-conferma").modal('show');
            }

            vm.conferma = function () {
                angular.element("#modal-conferma").modal('hide');
                vm.invioClicked = true;
                var data = vm.input;
                data.azione = vm.azioneConferma;
                $timeout(function () {
                    $window.scroll(0, 0);
                    ResourceService.inviaRichiesta(data, vm.inputCaptcha).then(
                        function (response) {
                            vm.input = {};
                            vm.invioClicked = false;
                            vm.formRicerca.$setPristine();
                            vm.datiInvio = data;
                            vm.abilitaCaricamentoFileP7m = true;
                            vm.azioneConferma = 'upload';
                            MessageService.clearMessages();
                            vm.reloadCaptcha();
                        }, function (response) {
                            $log.error(response);
                            vm.invioClicked = false;
                            vm.abilitaCaricamentoFileP7m = false;
                            vm.reloadCaptcha();
                            response.data.messages[0].severity = 'ERROR';
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();

                        });
                }, 500);
            }

            vm.confermaInvio = function () {
                angular.element("#modal-conferma").modal('hide');
                vm.invioClicked = true;
                var data = vm.datiInvio;
                data.azione = vm.azioneConferma;
                data.fileDelega = vm.input.fileDelega;
                $timeout(function () {
                    $window.scroll(0, 0);
                    ResourceService.inviaRichiesta(data, vm.inputCaptcha).then(
                        function (response) {
                            vm.input = {};
                            vm.invioClicked = false;
                            vm.formRicerca.$setPristine();
                            vm.abilitaCaricamentoFileP7m = false;
                            vm.fileInviato = true;
                            MessageService.clearMessages();
                            var message = {};
                            message.severity = 'SUCCESS';
                            message.message = 'Operazione correttamente eseguita. Il file firmato è stato inviato.';
                            MessageService.setMessages([message]);
                            MessageService.showMessages();
                            vm.reloadCaptcha();
                        }, function (response) {
                            $log.error(response);
                            vm.invioClicked = false;
                            vm.fileInviato = false;
                            vm.abilitaCaricamentoFileP7m = true;
                            vm.reloadCaptcha();
                            response.data.messages[0].severity = 'ERROR';
                            MessageService.setMessages(response.data.messages);
                            MessageService.showMessages();

                        });
                }, 500);
            }

            vm.initFn = function (loadImg) {
                vm.reloadCaptcha = loadImg;
            }

        };

        return invioAccreditamentoControllers;
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/controllers/invio-accreditamento-controllers.js
// module id = 33
// module chunks = 1